import enLocale from 'date-fns/locale/en/index.js';
import { FormattedMessage } from 'react-intl';

import NextRepaymentText from './nextRepaymentText/NextRepaymentText';
import { ListSVG } from '../../../../svgComponents/listSVG/index';
import messages from './StatusLines.messages';
import styles from './StatusLines.module.css';

export const StatusLines = ({
    hasRepaymentSchedule,
    totalBalance,
    isPaymentOverdue,
    repaymentDate,
    repaymentAmount,
    showSchedule,
    isSecondCBILSOffer
}: {
    hasRepaymentSchedule: boolean;
    totalBalance: number;
    repaymentDate: string;
    repaymentAmount: number;
    showSchedule: () => void;
    isPaymentOverdue?: boolean;
    isSecondCBILSOffer?: boolean;
}) => {
    if (!totalBalance) {
        return null;
    }

    if (hasRepaymentSchedule) {
        return (
            <div className={styles.StatusLines}>
                <div className={styles.nextRepayment}>
                    <NextRepaymentText
                        locale={enLocale}
                        totalBalance={totalBalance}
                        amount={repaymentAmount}
                        date={repaymentDate}
                        isPaymentOverdue={isPaymentOverdue}
                    />
                </div>
                <div className={styles.showSchedule}>
                    <span className={styles.link} onClick={showSchedule}>
                        {isSecondCBILSOffer ? (
                            'See full 2nd CBILS repayment schedule'
                        ) : (
                            <FormattedMessage
                                {...messages.seeRepaymentSchedule}
                            />
                        )}
                    </span>
                </div>
            </div>
        );
    } else {
        return (
            <div className={styles.showSchedule}>
                <span className={styles.icon}>
                    <ListSVG />
                </span>
                <span className={styles.link} onClick={showSchedule}>
                    <FormattedMessage {...messages.seeRepaymentBreakdown} />
                </span>
            </div>
        );
    }
};
